export default __webpack_public_path__ + "static/headstand-shoulderstrength-header-77de6d2c7ee858a41f1efcea89897811.png";